module.exports = __webpack_public_path__ + "assets/img/26_1590.cbf68876.jpg";